import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import axios from "axios";
import { API } from "../../../../backend";
import authHeader from "../../../../services/auth-header";
import LoanPaymentDetailView from "../Paymentdetails/ViewPaymentDetail/LoanPaymentDetailview";
import Helper from "../../../../Helper";
import AmortizationScheduleArrears from "../AmortSchedulDetail/ArrearsAmortSchedule";
import { getTrans as t } from "../../../../Localization/translations";
import jsPDF from "jspdf";
// import "jspdf-autotable";
import { autoTable } from 'jspdf-autotable'
import { Tabs, Tab } from "react-tabs";

export default function LoanDueDayChangePane({
  contractdetails,
  draftContract,
  contractId,
  draftId,
  recalcVersion,
  onReadyToSave,
  onDraftCreated,
}) {
  const [currentDueDay, setCurrentDueDay] = useState("");
  const [newDueDay, setNewDueDay] = useState("");

  const [existing, setExisting] = useState([]);
  const [updated, setUpdated] = useState([]);
  const [calcSchedule, setCalcSchedule] = useState([]);
  const [mergedPaymentDetails, setMergedPaymentDetails] = useState([]);
  const [parentPaymentDetails, setParentPaymentDetails] = useState([]);
  const [amortData, setAmortData] = useState([]);
  const [activeTab, setActiveTab] = useState("payment_schedule");

   function getAlignmentStyles(columns) {
    const alignmentStyles = {};
    columns.forEach((columnDef, index) => {
      if (columnDef.field === 'periodicpaymentAmount') {
        alignmentStyles[index] = { halign: 'right' };
      }
      else if (columnDef.field === 'beginBV') {
        alignmentStyles[index] = { halign: 'right' };
      }
      else if (columnDef.field === 'income') {
        alignmentStyles[index] = { halign: 'right' };
      }
      else if (columnDef.field === 'paymentAmount') {
        alignmentStyles[index] = { halign: 'right' };
      }
      else if (columnDef.field === 'capitalRecovery') {
        alignmentStyles[index] = { halign: 'right' };
      }
      else if (columnDef.field === 'rentalincome') {
        alignmentStyles[index] = { halign: 'right' };
      }
      else if (columnDef.field === 'bookDepericiation') {
        alignmentStyles[index] = { halign: 'right' };
      }
      else if (columnDef.field === 'endBV') {
        alignmentStyles[index] = { halign: 'right' };
      }
      else if (columnDef.field === 'incomeRecognized') {
        alignmentStyles[index] = { halign: 'right' };
      }
      else {
        alignmentStyles[index] = { halign: 'left' };
      }
    });
    return alignmentStyles;
  }

  const getDueDay = (source) => {
    if (!source) return "";

    const directDay =
      source.due_day_change ||
      source.due_day ||
      source.new_due_day ||
      source.payment_due_day;

    if (directDay) return Number(directDay);

    const dueDate =
      source.paymentstartdate ||
      source.paymentstart_date ||
      source.payment_start_date ||
      source.start_date;

    if (!dueDate) return "";

    const dt = new Date(dueDate);
    return Number.isNaN(dt.getTime()) ? "" : dt.getDate();
  };

  useEffect(() => {
    const currentDay = getDueDay(contractdetails);
    const draftDay = getDueDay(draftContract);

    setCurrentDueDay(currentDay);
    setNewDueDay(draftDay || currentDay);
  }, [contractdetails, draftContract]);

  const handleGenerate = async () => {
    if (!newDueDay || newDueDay < 1 || newDueDay > 31) {
      return alert("Due day must be between 1-31");
    }

    try {
      // 1️⃣ Create Draft
      const res = await axios.post(
        `${API}contracts/contracts/${contractId}/loan-modify/`,
        {
          amendment_type: "DUE_DAY_CHANGE",
          due_day_change: parseInt(newDueDay),
        },
        { headers: authHeader() }
      );

      const draftContractId = res.data.draft_contract_id;

      if (typeof onDraftCreated === "function") {
        onDraftCreated(draftContractId);
      }

      // 2️⃣ Recalculate Schedule
      await axios.post(
        `${API}contracts/contracts/${draftContractId}/loan-payment-schedule/`,
        {},
        { headers: authHeader() }
      );

      // 3️⃣ Existing Schedule
      const existingRes = await axios.get(
        `${API}contracts/payment-view/${contractId}/`,
        { headers: authHeader() }
      );

      setExisting(existingRes.data || []);

      // 4️⃣ New Schedule
      const updatedRes = await axios.get(
        `${API}contracts/payment-view/${draftContractId}/`,
        { headers: authHeader() }
      );

      setUpdated(updatedRes.data || []);

      // 5️⃣ Calc Schedule
      const calcRes = await axios.get(
        `${API}contracts/LoanmodificationpaymentSchedule/?id=${draftContractId}`,
        { headers: authHeader() }
      );

      setCalcSchedule(calcRes.data.response || []);

      // 6️⃣ Parent Payment Details
      const parentRes = await axios.get(
        `${API}contracts/paymentDetail-view/${contractId}/`,
        { headers: authHeader() }
      );

      setParentPaymentDetails(parentRes.data || []);

      // 7️⃣ Amort
      const amortRes = await axios.get(
        `${API}contracts/amortCalculation/?id=${draftContractId}`,
        { headers: authHeader() }
      );

      setAmortData(amortRes.data.response || []);
    } catch (e) {
      console.log(e);
      alert("Failed to generate due day change");
    }
  };

  useEffect(() => {
    axios
      .get(`${API}contracts/payment-view/${contractId}/`, {
        headers: authHeader(),
      })
      .then((res) => setExisting(res.data || []));

    if (!draftId) {
      setUpdated([]);
      setCalcSchedule([]);
      setParentPaymentDetails([]);
      setAmortData([]);
      setMergedPaymentDetails([]);
      return;
    }

    // Existing schedule (parent)
    axios
      .get(`${API}contracts/payment-view/${contractId}/`, {
        headers: authHeader(),
      })
      .then((res) => setExisting(res.data || []));

    // New schedule (draft)
    axios
      .get(`${API}contracts/payment-view/${draftId}/`, {
        headers: authHeader(),
      })
      .then((res) => {
        const rows = res.data || [];
        setUpdated(rows);

        const firstDraftDate =
          rows[0]?.payment_start_date ||
          rows[0]?.paymentstart_date ||
          rows[0]?.paymentstartdate ||
          rows[0]?.start_date;

        if (!draftContract && firstDraftDate) {
          const dt = new Date(firstDraftDate);
          if (!Number.isNaN(dt.getTime())) {
            setNewDueDay(dt.getDate());
          }
        }
      });

    // 🔥 Payment Details (AFTER recalculation)
    axios
      .get(`${API}contracts/LoanmodificationpaymentSchedule/?id=${draftId}`, {
        headers: authHeader(),
      })
      // .then((res) => setPaymentDetails(res.data.response));
      .then((res) => setCalcSchedule(res.data.response || []));

    axios
      .get(`${API}contracts/paymentDetail-view/${contractId}/`, {
        headers: authHeader(),
      })
      .then((res) => setParentPaymentDetails(res.data || []));

    axios
      .get(`${API}contracts/amortCalculation/?id=${draftId}`, {
        headers: authHeader(),
      })
      .then((res) => setAmortData(res.data.response || []));

    // }, [contractId, draftId,recalcVersion]);
  }, [contractId, draftId, recalcVersion, draftContract]);

  // ==========================================
  // MERGE LOGIC
  // ==========================================

  useEffect(() => {
      if (!parentPaymentDetails.length || !calcSchedule.length) return;
  
      // -------------------------------
      // 1️⃣ Split parent rows
      // -------------------------------
      const parentInterestOnly = parentPaymentDetails.filter(
        (p) => p.paymenttype === "Interest Only",
      );
  
      const calcInterestOnly = calcSchedule.filter(
        (p) => p.payment_type === "Interest Only",
      );
  
      const ioPeriodSet = new Set(
    calcInterestOnly.map(c => `${c.startdate}_${c.enddate}`)
  );
  
      // const calcRent = calcSchedule.filter((p) => p.payment_type === "Rent");
      const calcRent = calcSchedule
    .filter((p) => p.payment_type === "Rent")
    .filter((p) => {
      const key = `${p.startdate}_${p.enddate}`;
      return !ioPeriodSet.has(key); // ❌ remove overlap
    });
      const calcRentMap = {};
  calcRent.forEach((c) => {
    calcRentMap[`${c.startdate}_${c.enddate}`] = c;
  });
  
      const parentRent = parentPaymentDetails.filter(
        (p) => p.paymenttype === "Rent",
      );
  
      const billedRent = parentRent.filter((p) => p.date_billed);
      const unbilledRent = parentRent.filter((p) => !p.date_billed);
  
      const lastBilledPmtNo =
        billedRent.length > 0
          ? Math.max(...billedRent.map((r) => Number(r.pmt_no)))
          : 0;
        const anyBilled = parentPaymentDetails.some(
      (p) => p.date_billed !== null
    );
  
  
      const merged = [];
  
      // -------------------------------
      // 2️⃣ Always keep Interest Only
      // -------------------------------
      // parentInterestOnly.forEach(p => {
      //   merged.push({
      //     id: p.id,
      //     paymentdate: p.paymentdate,
      //     startdate: p.startdate,
      //     enddate: p.enddate,
      //     payment_type: "Interest Only",
  
      //     periodicamount_decimal2: p.periodicamount_decimal2,
      //     interest_decimal2: p.interest_decimal2,
      //     principal_decimal2: 0,
  
      //     beg_receivable: p.beginbv,
      //     end_receivable: p.endbv,
  
      //     pmt_no: p.pmt_no,
      //     billed: true,
      //     date_billed: p.date_billed,
      //     txn_number: p.transaction_number,
      //     paymentdetail_id: p.transaction_number,
  
      //     source: "parent",
      //   });
      // });
      // calcInterestOnly.forEach(p => {
      //   merged.push({
      //     id: p.id,
      //     paymentdate: p.paymentdate,
      //     startdate: p.startdate,
      //     enddate: p.enddate,
      //     payment_type: "Interest Only",
  
      //     periodicamount_decimal2: p.periodicamount_decimal2,
      //     interest_decimal2: p.interest_decimal2,
      //     principal_decimal2: 0,
  
      //     beg_receivable: p.beg_receivable,
      //     end_receivable: p.end_receivable,
  
      //     pmt_no: p.pmt_no,
      //     billed: true,
      //     date_billed: p.date_billed,
      //     txn_number: p.transaction_number,
      //     paymentdetail_id: p.transaction_number,
  
      //     source: "parent",
      //   });
      // });
      parentInterestOnly.forEach((parentRow, index) => {
        const calc = calcInterestOnly[index];
  
        const isBilled = parentRow.date_billed !== null;
  
        merged.push({
          paymentdate: parentRow.paymentdate,
          startdate: parentRow.startdate,
          enddate: parentRow.enddate,
          payment_type: "Interest Only",
  
          periodicamount_decimal2: isBilled
            ? parentRow.periodicamount_decimal2
            : calc?.periodicamount_decimal2,
  
          interest_decimal2: isBilled
            ? parentRow.interest_decimal2
            : calc?.interest_decimal2,
  
          principal_decimal2: 0,
  
          beg_receivable: isBilled ? parentRow.beginbv : calc?.beg_receivable,
  
          end_receivable: isBilled ? parentRow.endbv : calc?.end_receivable,
  
          pmt_no: parentRow.pmt_no,
  
          billed: isBilled,
          date_billed: isBilled ? parentRow.date_billed : null,
  
          txn_number: isBilled ? parentRow.transaction_number : null,
          paymentdetail_id: isBilled ? parentRow.paymentdetail_id : null,
  
          source: isBilled ? "parent" : "calc",
        });
      });
  
      // -------------------------------
      // 3️⃣ Add billed Rent rows (as-is)
      // -------------------------------
      billedRent.forEach((p) => {
        merged.push({
          id: p.id,
          paymentdate: p.paymentdate,
          startdate: p.startdate,
          enddate: p.enddate,
          payment_type: "Rent",
  
          periodicamount_decimal2: p.periodicamount_decimal2,
          interest_decimal2: p.interest_decimal2,
          principal_decimal2: p.Principal_decimal2,
  
          beg_receivable: p.beginbv,
          end_receivable: p.endbv,
  
          pmt_no: p.pmt_no,
          billed: true,
          date_billed: p.date_billed,
          txn_number: p.transaction_number,
          paymentdetail_id: p.transaction_number,
  
          source: "parent",
        });
      });
  
      // 🚨 IMPORTANT FIX
      // if (billedRent.length === 0) {
        if (!anyBilled) {
  
        const merged = [];
  
        // ✅ Interest Only from calc
        // calcInterestOnly.forEach(p => {
        //   merged.push({
        //     ...p,
        //     payment_type: "Interest Only",
        //     billed: false,
        //     source: "calc",
        //   });
        // });
        parentInterestOnly.forEach((parentRow, index) => {
          const calc = calcInterestOnly[index];
  
          merged.push({
            paymentdate: parentRow.paymentdate,
            startdate: parentRow.startdate,
            enddate: parentRow.enddate,
            payment_type: "Interest Only",
  
            periodicamount_decimal2: calc?.periodicamount_decimal2  !== undefined ? calc?.periodicamount_decimal2  : parentRow.periodicamount_decimal2,
            interest_decimal2: calc?.interest_decimal2 !== undefined ? calc?.interest_decimal2 : parentRow.interest_decimal2,
            principal_decimal2: 0,
  
            beg_receivable: calc?.beg_receivable !== undefined ? calc?.beg_receivable : parentRow.beginbv,
            end_receivable: calc?.end_receivable !== undefined ? calc?.end_receivable : parentRow.endbv,
  
            pmt_no: parentRow.pmt_no,
  
            billed: false,
            date_billed: null,
            txn_number: null,
  
            source: "calc",
          });
        });
  
        // ✅ Rent ONLY from calc
        // calcRent.forEach((p) => {
        //   merged.push({
        //     ...p,
        //     payment_type: "Rent",
        //     billed: false,
        //     source: "calc",
        //   });
        // ✅ Rent (use map, not index)
  calcRent.forEach((c) => {
    merged.push({
      paymentdate: c.paymentdate,
      startdate: c.startdate,
      enddate: c.enddate,
      payment_type: "Rent",
  
      periodicamount_decimal2: c.periodicamount_decimal2,
      interest_decimal2: c.interest_decimal2,
      principal_decimal2: c.principal_decimal2,
  
      beg_receivable: c.beg_receivable,
      end_receivable: c.end_receivable,
  
      pmt_no: c.pmt_no,
  
      billed: false,
      date_billed: null,
      txn_number: null,
  
      source: "calc",
    });
  
        });
  
        setMergedPaymentDetails(merged);
        return; // ⛔ STOP execution here
      }
  
      // -------------------------------
      // 4️⃣ Overlay calc rows onto unbilled rent
      // -------------------------------
      unbilledRent.forEach((parentRow, index) => {
        // const calc = calcSchedule[index]; // 👈 index-based, NOT date-based
        // const calc =     calcRent[index]; // 👈 index-based, NOT date-based
        // const calc = calcRent[billedRent.length + index];
        const key = `${parentRow.startdate}_${parentRow.enddate}`;
        const calc = calcRentMap[key];
        merged.push({
          paymentdate: parentRow.paymentdate,
          startdate: parentRow.startdate,
          enddate: parentRow.enddate,
          payment_type: "Rent",
  
          periodicamount_decimal2: calc
           ? calc.periodicamount_decimal2
            : parentRow.periodicamount_decimal2, 
      //     periodicamount_decimal2: calc?.periodicamount_decimal2 !== undefined
      // ? calc.periodicamount_decimal2
      // : parentRow.periodicamount_decimal2,
  
          interest_decimal2: calc
            ? calc.interest_decimal2
            : parentRow.interest_decimal2,
  
          principal_decimal2: calc
            ? calc.principal_decimal2
            : parentRow.Principal_decimal2,
  
          beg_receivable: calc ? calc.beg_receivable : parentRow.beginbv,
  
          end_receivable: calc ? calc.end_receivable : parentRow.endbv,
  
          pmt_no: parentRow.pmt_no,
          billed: false,
          date_billed: null,
          txn_number: null,
  
          source: "calc",
        });
        console.log("BILLED COUNT", billedRent.length);
        console.log("CALC RENT LENGTH", calcRent.length);
      });
  
      // -------------------------------
      // 5️⃣ Final sort
      // -------------------------------
      merged.sort((a, b) => {
        if (Number(a.pmt_no) === Number(b.pmt_no)) {
          return new Date(a.paymentdate) - new Date(b.paymentdate);
        }
        return Number(a.pmt_no) - Number(b.pmt_no);
      });
  
      setMergedPaymentDetails(merged);
  }, [parentPaymentDetails, calcSchedule, amortData]);
  useEffect(() => {
      if (
        mergedPaymentDetails.length > 0 &&
        typeof onReadyToSave === "function"
      ) {
        onReadyToSave(mergedPaymentDetails, amortData);
      }
    }, [mergedPaymentDetails, amortData]);

    const tabButtonStyle = (tabName) => ({
  border: "none",
  background:
    activeTab === tabName
      ? "var(--bs-primary)"
      : "transparent",

  color:
    activeTab === tabName
      ? "#fff"
      : "var(--bs-body-color)",

  padding: "10px 18px",
  borderRadius: "8px",
  fontWeight: 600,
  fontSize: "14px",
  cursor: "pointer",
  transition: "0.2s",
});

  return (
    <>
      <div className="card mt-3">
        <div className="card-body">

          <div className="row">

            <div className="col-md-4">
              <label className="form-label tc">Current Due Day</label>

              <input
                className="form-control"
                value={currentDueDay}
                disabled
              />
            </div>

            <div className="col-md-4">
              <label className="form-label tc">New Due Day</label>

              <select
                className="form-control"
                value={newDueDay}
                onChange={(e) => setNewDueDay(e.target.value)}
              >
                {[...Array(31)].map((_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {i + 1}
                  </option>
                ))}
              </select>
            </div>
            </div>

            <div className="col-md-4 mt-3 d-flex align-items-end">
              <button
                className="btn btn-primary"
                onClick={handleGenerate}
              >
                Save
              </button>
            {/* </div> */}

          </div>
        </div>
      </div>

      {/* Existing Schedule */}

      {/* <h5 className="mt-4">
        Existing Payment Schedule
      </h5>

      <ScheduleTable
        data={existing}
        contractType="Loan"
      /> */}

      {/* New Schedule */}

      {/* <h5 className="mt-4">
        New Payment Schedule
      </h5>

      <ScheduleTable
        data={updated}
        contractType="Loan"
      /> */}

      {/* Payment Details */}

     
{/* 
      <LoanPaymentDetailView
        contracttype="Loan"
        paymentdetails={mergedPaymentDetails}
      /> */}

      {/* Amort */}
   <div
  className="mt-4"
  style={{
    borderBottom: "1px solid #dbe4f0",
    display: "flex",
    gap: "40px",
    overflowX: "auto",
  }}
>
  <div
    onClick={() => setActiveTab("payment_schedule")}
    style={{
      padding: "14px 4px",
      cursor: "pointer",
      fontWeight: activeTab === "payment_schedule" ? "600" : "500",
      fontSize: "14px",

      color:
        activeTab === "payment_schedule"
          ? "#245c7f"
          : "#94a3b8",

      borderBottom:
        activeTab === "payment_schedule"
          ? "3px solid #245c7f"
          : "3px solid transparent",

      transition: "0.2s ease",
      whiteSpace: "nowrap",
    }}
  >
    Payment Schedule
  </div>

  <div
    onClick={() => setActiveTab("payment_details")}
    style={{
      padding: "14px 4px",
      cursor: "pointer",
      fontWeight: activeTab === "payment_details" ? "600" : "500",
      fontSize: "14px",

      color:
        activeTab === "payment_details"
          ? "#245c7f"
          : "#94a3b8",

      borderBottom:
        activeTab === "payment_details"
          ? "3px solid #245c7f"
          : "3px solid transparent",

      transition: "0.2s ease",
      whiteSpace: "nowrap",
    }}
  >
    Payment Details
  </div>

  <div
    onClick={() => setActiveTab("amort_schedule")}
    style={{
      padding: "14px 4px",
      cursor: "pointer",
      fontWeight: activeTab === "amort_schedule" ? "600" : "500",
      fontSize: "14px",

      color:
        activeTab === "amort_schedule"
          ? "#245c7f"
          : "#94a3b8",

      borderBottom:
        activeTab === "amort_schedule"
          ? "3px solid #245c7f"
          : "3px solid transparent",

      transition: "0.2s ease",
      whiteSpace: "nowrap",
    }}
  >
    Amort Schedule
  </div>
</div>

{/* PAYMENT SCHEDULE */}

{activeTab === "payment_schedule" && (
  <>
    <div className="card border-0 shadow-sm mb-3">
      <div className="card-body">

        <h6
          style={{
            fontWeight: 600,
            marginBottom: "15px",
          }}
        >
          Existing Payment Schedule
        </h6>

        <ScheduleTable
          data={existing}
          contractType="Loan"
        />

      </div>
    </div>

    <div className="card border-0 shadow-sm">
      <div className="card-body">

        <h6
          style={{
            fontWeight: 600,
            marginBottom: "15px",
          }}
        >
          New Payment Schedule
        </h6>

        <ScheduleTable
          data={updated}
          contractType="Loan"
        />

      </div>
    </div>
  </>
)}

{/* PAYMENT DETAILS */}

{activeTab === "payment_details" && (
  <div className=" border-0 "  style={{
    overflowX: "auto",
  }}>
    <div className="">

      {/* <h6
        style={{
          fontWeight: 600,
          marginBottom: "15px",
        }}
      >
        Payment Details
      </h6> */}

      <LoanPaymentDetailView
        contracttype="Loan"
        paymentdetails={mergedPaymentDetails}
        />
        </div>

    </div>
  
)}

{/* AMORT SCHEDULE */}

{activeTab === "amort_schedule" && (
  <div className="card border-0 shadow-sm">
    <div className="card-body">

      <h6
        style={{
          fontWeight: 600,
          marginBottom: "15px",
        }}
      >
        Amort Schedule
      </h6>

      {/* <h5 className="mt-4">
        Amort Schedule
      </h5> */}

               <MaterialTable
                      style={{
                        backgroundColor: "var(--bs-table-bg)",
                        borderBottomWidth: "1px",
                        boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                      }}
                      title={<> <span className="required">Amortization Schedule</span> -{" "}
                        <span style={{ fontSize: "14px" }}>
                          Actual Amortization Schedule will be generated on contract
                          activation
                        </span></>}
                      columns={[
                        {
                          title: `${t("Date")}`,
                          field: "paymentDate",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">{t("Date")}</div>
                              <div> {Helper.DateNormal(rowData.paymentDate)}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },
                        {
                          title: `${t("Payment Amount")}`,
                          field: "paymentAmount",
                          render: (rowData) => (
                            <>
                              <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                              >
                                {t("Payment Amount")}
                              </div>
                              <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                {" "}
                                {rowData.paymentAmount !== 0
                                  ? Helper.Amount(rowData.paymentAmount)
                                  : ""}
                              </div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "right",
                          },
                          // cellStyle: {
                          //   textAlign: "right",
                          //   fontSize: 12,
                          // },
                        },
                        {
                          title: `${t("Start Date")}`,
                          field: "startDate",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">{t("Start Date")}</div>
                              <div>{Helper.DateNormal(rowData.startDate)}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },
                        {
                          title: `${t("End Date")}`,
                          field: "endDate",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">{t("End Date")}</div>
                              <div>{Helper.DateNormal(rowData.endDate)}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },
                        {
                          title: `${t("No Of Days")}`,
                          field: "noOfDays",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">{t("No Of Days")}</div>
                              <div>{rowData.noOfDays}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },
                        {
                          title: `${contractdetails.contract_type === "Loan"
                            ? t("Interest Date")
                            : t("Income Date")
                            }`,
                          field: "incomeDate",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">
                                {contractdetails.contract_type === "Loan"
                                  ? t("Interest Date")
                                  : t("Income Date")}
                              </div>
                              <div>{Helper.DateNormal(rowData.incomeDate)}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },
                        {
                          title: `${contractdetails.contract_type === "Loan"
                            ? t("Begining Principal")
                            : t("Begin Bv")
                            }`,
                          field: "beginBV",
                          render: (rowData) => (
                            <>
                              <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                              >
                                {contractdetails.contract_type === "Loan"
                                  ? t("Begining Principal")
                                  : t("Begin Bv")}
                              </div>
                              <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.beginBV)}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "right",
                          },
                          // cellStyle: {
                          //   textAlign: "right",
                          //   fontSize: 12,
                          // },
                        },
                        {
                          title: `${contractdetails.contract_type === "Loan" ? t("Interest") : t("Income")
                            }`,
                          field: "income",
                          render: (rowData) => (
                            <>
                              <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                              >
                                {contractdetails.contract_type === "Loan"
                                  ? t("Interest")
                                  : t("Income")}
                              </div>
                              <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.income)}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "right",
                          },
                          // cellStyle: {
                          //   textAlign: "right",
                          //   fontSize: 12,
                          // },
                        },
                        {
                          title: `${t("Principal")}`,
                          field: "capitalRecovery",
                          render: (rowData) => (
                            <>
                              <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                              >
                                {t("Principal")}
                              </div>
                              <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                {Helper.Amount(rowData.capitalRecovery)}
                              </div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "right",
                          },
                          // cellStyle: {
                          //   textAlign: "right",
                          //   fontSize: 12,
                          // },
                        },

                        {
                          title: `${contractdetails.contract_type === "Loan"
                            ? t("Ending Principal")
                            : t("End Bv")
                            }`,
                          field: "endBV",
                          render: (rowData) => (
                            <>
                              <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                              >
                                {contractdetails.contract_type === "Loan"
                                  ? t("Ending Principal")
                                  : t("End Bv")}
                              </div>
                              <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.endBV)}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "right",
                          },
                          // cellStyle: {
                          //   textAlign: "right",
                          //   fontSize: 12,
                          // },
                        },
                        {
                          title: `${contractdetails.contract_type === "Loan"
                            ? t("Interest Recognized")
                            : t("Income Recognized")
                            }`,
                          field: "incomeRecognized",
                          render: (rowData) => (
                            <>
                              <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                              >
                                {contractdetails.contract_type === "Loan"
                                  ? t("Interest Recognized")
                                  : t("Income Recognized")}
                              </div>
                              <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                {rowData.incomeRecognized !== 0
                                  ? Helper.Amount(rowData.incomeRecognized)
                                  : ""}
                              </div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "right",
                          },
                          // cellStyle: {
                          //   textAlign: "right",
                          //   fontSize: 12,
                          // },
                        },
                      ]}
                      data={amortData}
                      options={{
                        headerStyle: {
                          backgroundColor: "white",
                          color: "#245C7F",
                          fontSize: 10,
                        },
                        rowStyle: (rowData, index) => {
                          if (index % 2) {
                            return { backgroundColor: "#fff" };
                          }
                        },
                        sorting: true,
                        search: false,
                        toolbar: true,
                        paging: true,
                        pageSize: 10, // make initial page size
                        emptyRowsWhenPaging: false, // To avoid of having empty rows
                        pageSizeOptions: [10, 15, 20, 50],
                        paginationType: "stepped",
                        showFirstLastPageButtons: false,
                        exportAllData: true,
                        exportButton: true,
                        exportFileName: "Amortization Schedule",
                        exportCsv: async (columns, data) => {
                          try {
                            const title = "Amortization Schedule";
                            const currentDate = new Date().toLocaleDateString();

                            const csvContentWithInfo = `${title}\n Date: ${currentDate}\n \n\n`;

                            const csvColumns = columns.map(columnDef => columnDef.title);
                            const csvData = data.map(rowData => {
                              const rowDataArray = columns.map(columnDef => {
                                if (columnDef.field === "paymentAmount") {
                                  return (
                                    rowData.paymentAmount !== 0
                                      ? Helper.Amount(rowData.paymentAmount)
                                      : ""
                                  );
                                } else if (columnDef.field === 'beginBV') {
                                  return (rowData.beginBV !== 0
                                    ? Helper.Amount(rowData.beginBV) : ''
                                  )
                                }
                                else if (columnDef.field === 'income') {
                                  return (rowData.income !== 0
                                    ? Helper.Amount(rowData.income) : ''
                                  )
                                } else if (columnDef.field === 'capitalRecovery') {
                                  return (rowData.capitalRecovery !== 0
                                    ? Helper.Amount(rowData.capitalRecovery) : ''
                                  )
                                } else if (columnDef.field === 'endBV') {
                                  return (rowData.endBV !== 0
                                    ? Helper.Amount(rowData.endBV) : ''
                                  )
                                } else if (columnDef.field === 'incomeRecognized') {
                                  return (rowData.incomeRecognized !== 0
                                    ? Helper.Amount(rowData.incomeRecognized) : ''
                                  )
                                }
                                else {
                                  return rowData[columnDef.field];
                                }
                              });
                              return rowDataArray;
                            });

                            const csvRows = [csvColumns, ...csvData];
                            const csvContent = `${csvContentWithInfo}${csvRows.map(row => {
                              return row.map(field => {
                                if (field === null || field === undefined) {
                                  return '""'; // Represent null values as an empty string in double quotes
                                }
                                if (typeof field === 'string' && field.includes(',')) {
                                  return `"${field}"`;
                                } else {
                                  return field;
                                }
                              }).join(',');
                            }).join('\n')}`;
                            // const csvContent = csvRows.map(row => row.join(',')).join('\n');

                            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                            const link = document.createElement('a');
                            link.href = URL.createObjectURL(blob);
                            link.download = 'Amortization Schedule.csv';
                            link.style.display = 'none';
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                          } catch (error) {
                            console.error("Error exporting CSV:", error);

                            // Add this line to see the detailed error information in the console
                            console.error(error.stack);
                          }
                        },
                        exportPdf: (data, columns) => {
                          const doc = new jsPDF();
                          doc.setFont("helvetica", "bold");
                          doc.setFontSize(16);

                          const title = "Amortization Schedule";
                          doc.text(title, 14, 10);

                          doc.setFontSize(12);
                          doc.setFont("helvetica", "normal");
                          const currentDate = new Date().toLocaleDateString();
                          doc.text(`Date : ${currentDate}`, 14, 15);
                          const columnTitles = data.map(
                            (columnDef) => columnDef.title
                          );
                          const space = 22; // Adjust the space value as needed
                          const tableStartY = 5 + space;
                          const pdfData = columns.map((rowData) => {
                            const rowDataArray = data.map((columnDef) => {
                              if (columnDef.field === "paymentAmount") {
                                return (
                                  rowData.paymentAmount !== 0
                                    ? Helper.Amount(rowData.paymentAmount)
                                    : ""
                                );
                              } else if (columnDef.field === 'beginBV') {
                                return (rowData.beginBV !== 0
                                  ? Helper.Amount(rowData.beginBV) : ''
                                )
                              }
                              else if (columnDef.field === 'income') {
                                return (rowData.income !== 0
                                  ? Helper.Amount(rowData.income) : ''
                                )
                              } else if (columnDef.field === 'capitalRecovery') {
                                return (rowData.capitalRecovery !== 0
                                  ? Helper.Amount(rowData.capitalRecovery) : ''
                                )
                              } else if (columnDef.field === 'endBV') {
                                return (rowData.endBV !== 0
                                  ? Helper.Amount(rowData.endBV) : ''
                                )
                              } else if (columnDef.field === 'incomeRecognized') {
                                return (rowData.incomeRecognized !== 0
                                  ? Helper.Amount(rowData.incomeRecognized) : ''
                                )
                              }
                              else {
                                return rowData[columnDef.field];
                              }
                            });
                            return rowDataArray;
                          });
                          // doc.autoTable({
                          autoTable(doc, {
                            head: [columnTitles],
                            body: pdfData,
                            startY: tableStartY, // Adjust the vertical starting position of the table
                            styles: {
                              cellPadding: 2, // Adjust cell padding
                              fontSize: 5,
                            },
                            columnStyles: getAlignmentStyles(data) // Apply column alignment styles
                          });

                          doc.save(`Amortization Schedule.pdf`);
                        },
                        actionsColumnIndex: -1,
                      }}
                    />
                       </div>
    </div>
                    )
  }
  
      {/* <MaterialTable
        columns={[
          {
            title: "Payment Date",
            field: "paymentDate",
          },
          {
            title: "Opening",
            field: "beginBV",
            render: (rowData) =>
              Helper.Amount(rowData.beginBV),
          },
          {
            title: "Interest",
            field: "interest_amount",
            render: (rowData) =>
              Helper.Amount(rowData.interest_amount),
          },
          {
            title: "Principal",
            field: "principal_amount",
            render: (rowData) =>
              Helper.Amount(rowData.principal_amount),
          },
          {
            title: "Closing",
            field: "closing_balance",
            render: (rowData) =>
              Helper.Amount(rowData.closing_balance),
          },
        ]}
        data={amortData}
        options={{
          search: false,
          toolbar: false,
          paging: true,
           pageSize: 3,
        pageSizeOptions: [3,5, 10, 20],
        }}
      /> */}
    </>
  );
}

function ScheduleTable({ data, contractType }) {
  const columns = [
    {
      title: "No. Of Payments",
      field: "no_of_payments",
      render: (rowData) => (
        <>
          <div className="d-xl-none tc d-md-none d-lg-none">
            {"No. Of Payments"}
          </div>
          <div>{rowData.no_of_payments}</div>
        </>
      ),
      headerStyle: {
        verticalAlign: "inherit",
        fontWeight: "bold",
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
        fontSize: 12,
      },
    },
    {
      title: "Payment Type",
      field: "payment_type",
      render: (rowData) => (
        <>
          <div className="d-xl-none tc d-md-none d-lg-none">Payment Type</div>
          <div>{rowData.payment_type}</div>
        </>
      ),
      headerStyle: {
        verticalAlign: "inherit",
        fontWeight: "bold",
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
        fontSize: 12,
      },
    },
    {
      title: "Payment Amount",
      field: "amount",
      render: (rowData) => (
        <>
          <div className="d-xl-none tc d-md-none d-lg-none">Payment Amount</div>
          <div className="text-end">{Helper.Amount(rowData.amount)}</div>
        </>
      ),
      headerStyle: {
        verticalAlign: "inherit",
        fontWeight: "bold",
        textAlign: "right",
      },
      cellStyle: {
        textAlign: "left",
        fontSize: 12,
      },
    },

    // 🔥 INTEREST — ONLY FOR LOAN
    // ...(contractType === "Loan"
    //   ? [
    //       {
    //         title: "Interest",
    //         field: "interest",
    //         render: (rowData) => (
    //           <>
    //             <div className="d-xl-none tc d-md-none d-lg-none">Interest</div>
    //             <div className="text-end">
    //               {Helper.Amount(rowData.interest || 0)}
    //             </div>
    //           </>
    //         ),
    //         headerStyle: {
    //               verticalAlign: "inherit",
    //               fontWeight: "bold",
    //               textAlign: "left",
    //             },
    //             cellStyle: {
    //               textAlign: "left",
    //               fontSize: 12,
    //             },
    //       },
    //     ]
    //   : []),

    {
      title: "Start Date",
      field: "start_date",
      render: (rowData) => (
        <>
          <div className="d-xl-none tc d-md-none d-lg-none">Start Date</div>
          <div>{Helper.DateNormal(rowData.start_date)}</div>
        </>
      ),
      headerStyle: {
        verticalAlign: "inherit",
        fontWeight: "bold",
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
        fontSize: 12,
      },
    },
    {
      title: "End Date",
      field: "end_date",
      render: (rowData) => (
        <>
          <div className="d-xl-none tc d-md-none d-lg-none">End Date</div>
          <div>{Helper.DateNormal(rowData.end_date)}</div>
        </>
      ),
      headerStyle: {
        verticalAlign: "inherit",
        fontWeight: "bold",
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
        fontSize: 12,
      },
    },
  ];

 

 return (
     <MaterialTable
       style={{
         backgroundColor: "var(--bs-table-bg)",
         borderBottomWidth: "1px",
 
         boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
       }}
       columns={columns}
       data={data}
       options={{
         search: false,
         toolbar: false,
         paging: true,
         pageSize: 3,
         showFirstLastPageButtons: false,
         actionsColumnIndex: -1,
         emptyRowsWhenPaging: false, // To avoid of having empty rows
 
         pageSizeOptions: [3, 15, 20, 50],
         paginationType: "stepped",
 
         headerStyle: {
           backgroundColor: "white",
           color: "#245C7F",
           fontSize: 12,
         },
         rowStyle: (rowData) => ({
           backgroundColor:
             rowData.is_historical || rowData.billed ? "#f0f0f0" : "#ffffff",
           pointerEvents:
             rowData.is_historical || rowData.billed ? "none" : "auto",
         }),
       }}
     />
   );
 }
 
